export const roundDown = (target: number, interval: number): number => {
  return Math.floor(target / interval) * interval;
};
